export default __webpack_public_path__ + "static/media/portada-inicio.1702aada.webp";